import { api } from '@/core/helpers/axiosHelper';
import { Timetable } from './timetable.interface';

export default {
   async delete(timetable_id: number) {
      return await api.delete('/timetable/' + timetable_id);
   },
   async post(body: Timetable) {
      return await api.post('/timetable?include=timetable_weeks.timetable_days.timetable_hours', body).then((response) => response.data);
   },
   async patch(timetable_id: number, body: Array<{ op: string; path: string; value: any }>) {
      return await api
         .patch('/timetable/' + timetable_id + '?include=timetable_weeks.timetable_days.timetable_hours', body)
         .catch((err) => err)
         .then((response) => response.data);
   },
   async resequenceTimetableWeeks(timetable_id: number, body: any) {
      return await api
         .put(`/timetable/${timetable_id}/resequence-timetable-weeks?include=timetable_weeks.timetable_days.timetable_hours`, body)
         .catch((err) => err)
         .then((response) => response.data);
   },
};
